import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=dbf99dcc&"
import script from "./partners.vue?vue&type=script&lang=js&"
export * from "./partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports